import { render, staticRenderFns } from "./Fabbricati.vue?vue&type=template&id=a180f11a&"
import script from "./Fabbricati.vue?vue&type=script&lang=ts&"
export * from "./Fabbricati.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports